import { render, staticRenderFns } from "./index.vue?vue&type=template&id=17c1444f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=17c1444f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c1444f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c1444f')) {
      api.createRecord('17c1444f', component.options)
    } else {
      api.reload('17c1444f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=17c1444f&scoped=true", function () {
      api.rerender('17c1444f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/index.vue"
export default component.exports